import { cn } from "@/lib/utils";
import { Header } from "./Header";
import { HeaderButtons } from "./HeaderButtons";

export interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  headerButtons?: React.ReactNode;
  showNavigationButtons?: boolean;
  showSearch?: boolean;
  showLanguageToggle?: boolean;
  showMenuButton?: boolean;
  customPadding?: boolean;
  showHeader?: boolean;
}

export function PageLayout({
  children,
  className,
  headerButtons,
  showNavigationButtons = false,
  showSearch = false,
  showLanguageToggle = false,
  showMenuButton = true,
  customPadding = false,
  showHeader = true,
}: PageLayoutProps) {
  // Always show HeaderButtons when showNavigationButtons is true, regardless of other headerButtons
  const combinedHeaderButtons = showNavigationButtons ? (
    <>
      <HeaderButtons />
      {headerButtons}
    </>
  ) : (
    headerButtons
  );

  return (
    <div className={cn("h-screen overflow-hidden", className)}>
      {showHeader && (
        <Header
          headerButtons={combinedHeaderButtons}
          showSearch={showSearch}
          showLanguageToggle={showLanguageToggle}
          showMenuButton={showMenuButton}
        />
      )}
      {customPadding ? (
        children
      ) : (
        <div className="flex h-full flex-col">
          {showHeader && <div className="h-20 shrink-0" />}
          <div className="flex-1 overflow-auto px-4">{children}</div>
        </div>
      )}
    </div>
  );
}
